export default "__VITE_ASSET__Dtxlpjb0__"